// extracted by mini-css-extract-plugin
export default {"content":"Error_content__BUxN+","links":"Error_links__Uv7cX","button":"Error_button__mrOc2"};